<template>
  <div>
    <div class="record-depot">
      <div class="main-box">
        <div class="depot-list-box">
          <div class="left-filter">
            <div class="ft-box" v-if="subjectDict && subjectDict.length > 0">
              <div class="tit">
                <i></i>主题分类
                <span
                  :class="showAll[0] ? 'cur' : ''"
                  @click="showAllHandle(0)"
                ></span>
              </div>
              <div :class="showAll[0] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === subjectCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'subject')"
                >
                  <span>全部</span>
                  <!-- <span>{{ subjectCount }}</span> -->
                </div>
                <div
                  v-for="(item, index) in subjectDict"
                  :key="'subjectDict' + index"
                   :class="getFacetText('subjectDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'subject')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
            <div class="ft-box" v-if="plDict && plDict.length > 0">
              <div class="tit">
                <i></i>出版地点
                <span
                  :class="showAll[1] ? 'cur' : ''"
                  @click="showAllHandle(1)"
                ></span>
              </div>
              <div :class="showAll[1] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === plCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'pl')"
                >
                  <span>全部</span>
                  <!-- <span>{{ plCount }}</span> -->
                </div>
                <div
                  v-for="(item, index) in plDict"
                  :key="'plDict' + index"
                :class="getFacetText('plDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'pl')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
            <div class="ft-box" v-if="langDict && langDict.length > 0">
              <div class="tit">
                <i></i>语种
                <span
                  :class="showAll[2] ? 'cur' : ''"
                  @click="showAllHandle(2)"
                ></span>
              </div>
              <div :class="showAll[2] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === langCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'lang')"
                >
                  <span>全部</span>
                  <!-- <span>{{ langCount }}</span> -->
                </div>
                <div
                  v-for="(item, index) in langDict"
                  :key="'langDict' + index"
                 :class="getFacetText('langDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'lang')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="right-content">
            <div class="result-count">
              <div class="all-num">
                <span
                  >共<b>{{ rowCount }}</b
                  >首</span
                >
                <b class="all-check" @click="allCheckClick">
                  <img
                    src="@/assets/images/icon/checked.png"
                    width="15"
                    v-if="allCheck == true"
                  />
                  <img
                    src="@/assets/images/icon/nochecked.png"
                    width="15"
                    v-else
                  />
                  全选
                </b>
              </div>
              <div class="m-c-p">
                  <b
                    class="m-c-p-b"
                    :class="
                      continuationPlay.length == 0
                        ? 'continuation-play-empty'
                        : 'continuation-play'
                    "
                    @click="continuationClick"
                  >
                    <img
                      v-if="continuationPlay.length == 0"
                      src="@/assets/images/icon/disabled.png"
                      width="15"
                    />
                    <img
                      v-else
                      src="@/assets/images/icon/Group.png"
                      width="15"
                    />

                    连播<i>{{ continuationPlay.length }}</i></b
                  >
                  <div
                    :class="
                      showMobileFilter ? 'mb-filter-btn cur' : 'mb-filter-btn'
                    "
                    @click.stop="showMobileFilter = !showMobileFilter"
                  >
                    筛选
                  </div>
                </div>
              <!-- <div class="list-tap">
                <span
                  :class="listType === 1 ? 'cur' : ''"
                  @click="listType = 1"
                ></span>
                <span
                  :class="listType === 2 ? 'cur' : ''"
                  @click="listType = 2"
                ></span>
              </div> -->
              <div class="sort">
                <span :class="sorts[0] ? 'cur' : ''" @click="onSorts(0)"
                  >题名</span
                >
                <span :class="sorts[1] ? 'cur' : ''" @click="onSorts(1)"
                  >出版时间</span
                >
                <span :class="sorts[2] ? 'cur' : ''" @click="onSorts(2)"
                  >责任者</span
                >
                <span
                  :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
                  @click="onlyCanPlay"
                  >可播放唱片</span
                >
                <b
                  :class="
                    continuationPlay.length == 0
                      ? 'continuation-play-empty'
                      : 'continuation-play'
                  "
                  @click="continuationClick"
                >
                  <img
                    v-if="continuationPlay.length == 0"
                    src="@/assets/images/icon/disabled.png"
                    width="15"
                  />
                  <img v-else src="@/assets/images/icon/Group.png" width="15" />

                  连播<i>{{ continuationPlay.length }}</i></b
                >
              </div>
              <!-- <div>
                <span  @click="onlyLxPlay"
                  >连播</span
                >
              </div> -->
            </div>

            <div class="filter-keys" v-if="filterKeys.length > 0">
              <div class="lb">已选项：</div>
              <div
                v-for="(f, index) in filterKeys"
                :key="index + f.text"
                class="f-k"
              >
                {{ f.text }} <i class="cls" @click="deleteFilter(index)"></i>
              </div>
            </div>
            <div class="result-list">
              <div
                v-for="(item, index) in recordList"
                :key="index"
                class="result-cell"
              >
                <div class="song-check" @click="checkClick(item, index)">
                  <img
                    src="@/assets/images/icon/checked.png"
                    width="15"
                    v-if="item.check == true && item.playable == true"
                  />
                  <img
                    src="@/assets/images/icon/nochecked.png"
                    width="15"
                    v-if="item.check == false && item.playable == true"
                  />
                </div>
                <div class="index">{{ index + 1 }}</div>
                <div class="pic">
                  <router-link
                    :to="'/rec-info/' + encodeURIComponent(item['@id'])"
                  >
                    <img
                      v-if="item.cover[0]"
                      :src="
                        'https://img.library.sh.cn/hisdata/cp/img/' +
                        item.cover[0]
                      "
                      alt=""
                    />
                    <img v-else :src="baseRecordPic" alt="" />
                  </router-link>
                </div>
               <div class="info">
                <router-link
                    :to="'/rec-info/' + encodeURIComponent(item['@id'])"
                  >
                <div
                  class="name"
                  v-if="item.title"
                  :title="item.title"
                >
                    {{
                      item.title
                        .replace("~", "")
                        .replace("=", "")
                        .replace(":", "")
                        .replace(/[||]/g, "#")
                        .replace(/##/g, "")
                    }}
                </div>
               
                <div class="des" v-if="item.date">
                  <span>{{ item.date }}年</span>
                </div>
                <div class="des" v-if="item.creator">
                  <span>{{ item.creator }}</span>
                </div>
               </router-link>
              </div> 
                <div class="act">
                  <!-- <span :class="playIndex == index ? 'play curPlay' : 'play'" @click="playSong(item,index)"></span> -->
                  <span v-if="!item.playable" class="noplay"></span>
                  <span
                    v-if="item.playable"
                    :class="playIndex == index ? 'play curPlay' : 'play'"
                    @click="playSong(item, index)"
                  ></span>
                  <span
                    :class="item.isFavorite ? 'fav cur' : 'fav'"
                    @click="handleFav(index)"
                  ></span>
                  <!-- <span class="share"></span> -->
                  <ShareIcon
                    :shareConfig="{
                      url: '/rec-info/' + encodeURIComponent(item['@id']),
                      title: item.title
                        .replace('~', '')
                        .replace('=', '')
                        .replace(':', '')
                        .replace(/[||]/g, '#')
                        .replace(/##/g, ''),
                    }"
                  ></ShareIcon>
                </div>
              </div>
            </div>
            <div class="page-box">
              <a-pagination
                :total="pagerCount"
                :current="currentPage"
                @change="onChange"
                show-quick-jumper
                show-less-items
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      :class="showMobileFilter ? 'mobile-filter-tk cur' : 'mobile-filter-tk'"
    >
     <div class="depot-filter" v-if="subjectDict && subjectDict.length > 0">
        <span class="lb">主题分类</span>
        <div class="scroll-box">
          <div class="fs" :style="'width:' + (subjectDict.length)*1.15 + 'rem'">
             <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
            <span
              :class="subjectCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1, -1, 'subject')"
              >全部</span
            >
            <span
              v-for="(item, index) in subjectDict"
              :key="'subjectDict' + index"
                :class="getFacetText('subjectDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item, index, 'subject')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
      <div class="depot-filter" v-if="plDict && plDict.length > 0">
        <span class="lb">出版地点</span>
        <div class="scroll-box">
          <div class="fs" :style="'width:' + (plDict.length+1)*0.8 + 'rem'">
           <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
            <span
              :class="plCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1, -1, 'pl')"
              >全部</span
            >
            <span
              v-for="(item, index) in plDict"
              :key="'plDict' + index"
                 :class="getFacetText('plDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item, index, 'pl')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
      <div class="depot-filter" v-if="langDict && langDict.length > 0">
        <span class="lb">语种</span>
        <div class="scroll-box">
          <div class="fs" :style="'width:' + (langDict.length+1) + 'rem'">
              <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
            <span
              :class="langCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1, -1, 'lang')"
              >全部</span
            >
            <span
              v-for="(item, index) in langDict"
             :key="'langDict' + index"
                  :class="getFacetText('langDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item, index, 'lang')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
      <div class="depot-slide">
        <div class="slide-box">
          <span class="lb">出版时间</span>
          <div class="slide">
            <a-slider
              range
              :min="1920"
              :max="1950"
              :default-value="[1920, 1950]"
            />
          </div>
        </div>
      </div>
      <div class="depot-filter">
        <div class="sort">
          <span
            :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
            @click="onlyCanPlay"
            >可播放曲目</span
          >
        </div>
      </div>
      
    </div>
    <Player ref="player" @curPlay="curPlay" />
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from "@/components/player";
import { baseRecordPic } from "@/util/basePic";
import ShareIcon from "@/components/shareIcon";
import {
  collFav,
  ncollFav,
  phonorecordList,
} from "@/api";

export default {
  components: {
    Nav,
    Footer,
    Player,
    ShareIcon,
  },
  data() {
    return {
      playIndex: -1,
      curIndex: -1,
      noplay: false,
      player: [],
      pageLoad: false,
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {}, // 检索参数
      hasAudio: false,
      onlyShowPlay: false,
      baseRecordPic,
      listType: 1,
      subjectCount: 0,
      subjectCurrent: -1,
      subjectDict: [],
      plCount: 0,
      plCurrent: -1,
      plDict: [],
      showMobileFilter: false,
      langCount: 0,
      langCurrent: -1,
      langDict: [],
      facesTitleKey: [
        { key: "subject", title: "主题分类" },
        { key: "pl", title: "出版地" },
        { key: "lang", title: "语种" },
      ],
      rowCount: 0,
      pagerCount: 1,
      currentPage: 1,
      totalPage: 10, // 每页总数
      recordList: [],
      showAll: [true, true, true],
      showAllSpan: [false, false, false, false, false, false],
      filterKeys: [],
      sorts: [true, false, false],
      //全选
      allCheck: false,
      //连播
      continuationPlay: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.body.addEventListener("click", () => {
        this.showMobileFilter = false;
      });
      this.searchParams = this.commonParamsHandling();
      this.query();
    });
  },
  beforeDestroy() {
    document.body.removeEventListener("click", () => {
      this.showMobileFilter = false;
    });
  },
  methods: {
    //点击勾选
    checkClick(item, index) {
      let changeItem = item;
      changeItem.check = changeItem.check == false ? true : false;
      this.recordList.splice(index, 1, changeItem);
      //选择的歌曲加入到连播列表中
      if (changeItem.check == false) {
        for (let i = 0; i < this.continuationPlay.length; i++) {
          if (changeItem["@id"] == this.continuationPlay[i]["@id"]) {
            this.continuationPlay.splice(i, 1);
            i--;
          }
        }
      } else {
        this.continuationPlay = this.continuationPlay.concat(item);
      }
      this.listIsAllCheck();
    },
    //校验当前列表是否是全选状态
    listIsAllCheck() {
      let isAllCheck = true;
      for (let i = 0; i < this.recordList.length; i++) {
        if (this.recordList[i].check == false) {
          isAllCheck = false;
          break;
        }
      }
      this.allCheck = isAllCheck;
    },
    //点击全选
    allCheckClick() {
      this.allCheck = this.allCheck == false ? true : false;
      let that = this;
      let continuationPlayArr = JSON.parse(
        JSON.stringify(this.continuationPlay)
      );
      
      this.recordList.forEach(function (item) {
        item.check = that.allCheck;
      });
      if (this.allCheck == true) {
        let arr = []
        this.recordList.forEach(function (item) {
          if(item.playable == true){
            arr.push(item)
          }
        });
        continuationPlayArr = continuationPlayArr.concat(arr);
      } else {
        for (let i = 0; i < this.recordList.length; i++) {
          for (let j = 0; j < continuationPlayArr.length; j++) {
            if (continuationPlayArr[j]["@id"] == this.recordList[i]["@id"]) {
              continuationPlayArr.splice(j, 1);
              j--;
            }
          }
        }
      }
      //连播列表进行去重
      if (continuationPlayArr.length != 0) {
        for (var i = 0; i < continuationPlayArr.length; i++) {
          for (var j = i + 1; j < continuationPlayArr.length; j++) {
            if (
              continuationPlayArr[i]["@id"] == continuationPlayArr[j]["@id"]
            ) {
              //第一个等同于第二个，splice方法删除第二个
              continuationPlayArr.splice(j, 1);
              j--;
            }
          }
        }
      }
      this.continuationPlay = continuationPlayArr;
    },
    //点击连播
    continuationClick() {
      if (this.continuationPlay.length == 0) {
        return;
      }
      for (var i = 0; i < this.continuationPlay.length; i++) {
        this.$refs.player.playSong(this.$parent, this.continuationPlay[i]);
      }
    },
    initData(flag = true, flag2 = true) {
      // 初始化
      this.recordList = [];
      this.rowCount = 0;
    },
    onParamsHandle() {
      // 检索参数设置
      // 初始化
      this.initData();
      this.searchParams = this.commonParamsHandling();
      if (this.hasAudio)
        // this.searchParams.facet = { hasAudio: this.hasAudio + "" };
        this.searchParams.resouce = { PLAY: "1" };
      // 排序
      this.searchParams.sorts = {};
      if (this.sorts[0]) this.searchParams.sorts.TI = 1;
      if (this.sorts[1]) this.searchParams.sorts.TIME = 1;
      if (this.sorts[2]) this.searchParams.sorts.CO = 1;
      // 页码翻页
      this.searchParams.pager.pageth = this.currentPage;
      this.searchParams.pager.pageSize = this.totalPage;
      if (this.filterKeys.length < 1) return;
      let sim = false;
      this.filterKeys.forEach((item, index) => {
        const dict = item.dict;
        // 简单检索
        if (dict == "keyword") {
          this.searchParams.searchType = 1;
          this.searchParams.freetext = item.text;
        }
        // 分面参数
        if (dict.indexOf("Dict") != -1) {
          this.searchParams.facet[dict.replace("Dict", "").toUpperCase()] =
            item.text;
        }
      });
    },
    async query(facetsFlag = true) {
      // this.pageLoad = true;是否刷新画面
      // 参数设置
      this.onParamsHandle();
      const res = await phonorecordList(this.searchParams);
      if (res) {
        this.pageLoad = false;
      }
      const result = res.data;
      //console.log(result);
      this.recordList = result.datas;
      //列表默认增加一个非选中的状态，用来处理连播使用
      if (this.recordList.length != 0) {
        for (let i = 0; i < this.recordList.length; i++) {
          this.recordList[i]["check"] = false;
        }
      }
      //如果连播列表存在，需要更新check状态
      if (this.continuationPlay.length != 0) {
        for (let i = 0; i < this.continuationPlay.length; i++) {
          for (let j = 0; j < this.recordList.length; j++) {
            if (this.continuationPlay[i]["@id"] == this.recordList[j]["@id"]) {
              this.recordList[j].check = true;
            }
          }
        }
      }
      if (facetsFlag) {
        // 主题分类
        this.subjectDict =
          result.facets && result.facets.subjectFacet
            ? result.facets.subjectFacet
            : [];
        // 出版地
        this.plDict =
          result.facets && result.facets.plFacet ? result.facets.plFacet : [];
        // 语种
        this.langDict =
          result.facets && result.facets.langFacet
            ? result.facets.langFacet
            : [];
      }
      // 统计数量
      this.facesTitleKey.forEach((item, index) => {
        this.countHnadle(item.key);
      });
      // 总数
      this.rowCount =
        result.pager && result.pager.rowCount ? result.pager.rowCount : 0;
      // 页码
      this.pagerCount =
        result.pager && result.pager.rowCount ? result.pager.rowCount : 1;
    },
    countHnadle(key) {
      // 统计数量
      this[key + "Count"] = 0;
      this[key + "Dict"].forEach((item, index) => {
        this[key + "Count"] += item.count;
      });
    },
    curPlay() {
      this.playIndex = this.curIndex;
    },
    async playSong(item, index) {
      this.curIndex = index;
      this.$refs.player.playSong(this.$parent, item);
    },
    nohandleCancel() {
      this.noplay = false;
    },
    onSorts(n) {
      // 排序
      // 排序
      this.sorts.splice(n, 1, !this.sorts[n]);
      let allFalse = 1;
      this.sorts.forEach((item, index) => {
        if (n != index) {
          this.sorts[index] = false;
        }
        if (item == true) {
          allFalse = 2;
        }
      });
      if (allFalse == 1) {
        this.sorts[0] = true;
      }
      this.query(false);
    },
    showAllHandle(a) {
      this.showAll.splice(a, 1, !this.showAll[a]);
      let count = 0;
      this.showAll.forEach((item) => {
        if (item) {
          count++;
        }
      });
      if (count > 3) {
        let flag = false;
        this.showAll.forEach((item, index) => {
          if (item && index !== a && !flag) {
            flag = true;
            this.showAll.splice(index, 1, false);
          }
        });
      }
    },
    async handleFav(index) {
      //点击收藏如果没有登录,则提示用户登录后方可操作
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$parent.showTk(2);
        return;
      }
      const res = this.recordList[index].isFavorite
        ? await ncollFav({ uri: this.recordList[index]["@id"] })
        : await collFav({ uri: this.recordList[index]["@id"] });
      this.recordList.splice(index, 1, {
        ...this.recordList[index],
        isFavorite: !this.recordList[index].isFavorite,
      });
      //取消收藏需要删除连播列表中的数据
      let changeItem = this.recordList[index];
      for (let i = 0; i < this.continuationPlay.length; i++) {
        if (changeItem["@id"] == this.continuationPlay[i]["@id"]) {
          this.continuationPlay.splice(i, 1);
          i--;
        }
      }

      this.$parent.coll(this.recordList[index].isFavorite);
      this.query();
    },
    deleteFilter(index) {
       let key = this.filterKeys[index].dict.substring(0,this.filterKeys[index].dict.search("Dict"));
      
      this[key + "Current" ] = -1;
      this.filterKeys.splice(index, 1);
      this.currentPage = 1;
      this.totalPage = 10;
      this.query();
    },
    changeShowAllSpan(index) {
      this.showAllSpan.splice(index, 1, !this.showAllSpan[index]);
    },
     getFacetText(key) {
     const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key ;
      });//是否找到了分面字典关键字 -1未找到如：subjectDict
      if(this.filterKeys[_i]){  return this.filterKeys[_i].text;}
      return '';
    },
   handleFilter(item, index, key) {
      this[key + "Current"] = item.facet ? item.facet : item;//被选中的分面值
      const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key + "Dict";
      });//是否找到了分面字典关键字 -1未找到如：subjectDict
      let facValue = this[key + "Dict"][index] && this[key + "Dict"][index].facet ? this[key + "Dict"][index].facet :'';//真正选中的分面值
      if (_i !== -1) {
          //如果是专题，则可以多选
          if(this.filterKeys[_i]){
            let tempList =this.filterKeys[_i].text.split(',');
              if(tempList.indexOf(facValue)==-1){//如果已转中数组中不存在当前值，则继续存入
                  if(facValue !=null && facValue!=''){
                  tempList.push(facValue);//被选中的主题分类数据
                  this.filterKeys[_i].text=tempList.join(',');
                  }
                  }
               else if(tempList.length>1) {//如果剩下的不是最后一个时候，允许移除
                tempList.splice(tempList.indexOf(facValue),1);//如果存在，则删除该值，重新查询
              }
              facValue =tempList.join(',');
           }
          if (index === -1) {
            this.filterKeys.splice(_i, 1);
            // console.log('index === -1')
          } else {
            this.filterKeys.splice(_i, 1, {dict: key + "Dict", text: facValue});
          }
      } else if(facValue !=null && facValue!=''){//选中的分面值，如果不为空 做新增
           this.filterKeys.push({dict: key + "Dict", text: facValue});
      }
      this.currentPage = 1;
      this.totalPage = 10;
      this.query();
    },
    nohandleCancel() {
      this.noplay = false;
    },
    onLoadMore(n) {
      this.totalPage += n;
      this.query(false);
    },
    onChange(current) {
      // 页码点击
      this.currentPage = current;
      this.query(false);
      this.allCheck = false;
    },
    onlyCanPlay() {
      // 仅显示可播放唱片
      this.onlyShowPlay = !this.onlyShowPlay;
      this.hasAudio = this.onlyShowPlay;
      this.query();
    },
    onlyLxPlay() {
      for (var i = 0; i < this.recordList.length; i++) {
        this.$refs.player.playSong(this.$parent, this.recordList[i]);
        // console.log(this.recordList[i]);
      }
    },
    listTypeChange(index) {
      // 页面切换
      this.listType = index;
      this.currentPage = 1;
      this.totalPage = 10;
      this.query(false);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.ant-slider-handle {
  background: #ffffff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  border: none;
  margin-top: -5px;
  width: 20px;
  height: 20px;
  &:focus {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  }
}
/deep/.ant-slider-track {
  background: #eb5757 !important;
}
/deep/.ant-slider-rail,
/deep/.ant-slider-track {
  height: 10px;
}
/deep/.ant-slider {
  margin-top: 4px;
}
</style>
